import { useLayoutEffect } from 'react';

export const useHideSplashScreenEffect = (hide: boolean = true) => {
  useLayoutEffect(() => {
    const splashScreen = document.getElementById('splash-screen');

    if (splashScreen && hide) {
      splashScreen.style.display = 'none';
    }
  }, [hide]);
};
